//
// Consider using the useFeatureFlag hook instead of this function
// **WARN** This function does not support Registry Flags
// This function should only be used for class components
// If possible convert the class component to a functional component and use the useFeatureFlag hook
//
import fetch from 'lib/fetch'
import Cookies from 'js-cookie'
import { apiV3BLLaunchDarklyFlagPath } from 'lib/urls'
import { isPrerenderUserAgent } from '../isPrerenderUserAgent'
import { getCurrentUser } from 'shared/utils/getCurrentUser/getCurrentUser'

// This function will use the babylist API as a proxy and will not use the LD client
export const ldGetFlag = (flagName: string, defaultValue: boolean | string) => {
  if (typeof window === 'undefined' || isPrerenderUserAgent()) {
    return defaultValue
  }

  let flagValue = defaultValue
  const currentUser = getCurrentUser()

  if (currentUser?.ldFlagsJson) {
    let flagsFromCurrentUser: Record<string, any> = {}
    try {
      flagsFromCurrentUser = JSON.parse(currentUser.ldFlagsJson)
    } catch (e) {
      console.error('Error parsing currentUser.ldFlags' + e)
    }
    if (flagsFromCurrentUser.hasOwnProperty(flagName)) {
      flagValue = flagsFromCurrentUser[flagName]
    }
  } else {
    // Read from cookie
    const blLdFlags = Cookies.get('bl_ld_flags')
    if (blLdFlags) {
      const ldFlags = JSON.parse(blLdFlags)
      flagValue = ldFlags[flagName]
    }
  }

  const path = `${apiV3BLLaunchDarklyFlagPath}?flag_name=${flagName}`
  fetch(path, { method: 'GET' })

  return flagValue
}
